import { createBrowserRouter, RouterProvider, } from "react-router-dom";
import LoginPage from './Login/Login';
import ProtectedRoute from "./ProtectedRoute";
import DashboardPage from "./Dashboard/Index";
import CommessePage from "./Commesse";
import CommessaPage from "./Commesse/CommessaPage";
import PersonalePage from "./Personale";
import Home from "./Home";

const router = createBrowserRouter([
    {
      path: "/",
      element: <LoginPage />,
    },
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      element: <ProtectedRoute/>,
      children: [
      {
        path: "/home",
        element: <Home />,
      },
      {
        path: "/dashboard",
        element: <DashboardPage />,
      },
      {
        path: "/commesse",
        element: <CommessePage />,
      },
      {
        path: "/commessa",
        element: <CommessaPage />
      },
      {
        path: "/dipendenti",
        element: <PersonalePage />
      }
      ]
    }
]);

const AppRoutes = () => {
  return (
    <RouterProvider router={router}/>
  );
};

export default AppRoutes;